
export default {
  props: {
    share: {
      type: Object,
      default: null,
    },
  },
  computed: {
    link () {
      return this.share.url.split(`#`)[0];
    },
    title () {
      return this.share.text;
    },
    twitterLink () {
      return `https://twitter.com/intent/tweet?url=${this.link}&text=${encodeURIComponent(this.title)}`;
    },
  },
  methods: {
    socialShare (channel, title, link) {
      switch (channel) {
      case `twitter`:
        window.open(
          `//twitter.com/intent/tweet?url=${this.link}&text=${title}`,
        );
        break;

      case `facebook`:
        window.open(
          `//www.facebook.com/sharer/sharer.php?u=${title}`,
          ``,
          `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600`,
        );
        break;

      case `linkedin`:
        window.open(
          `//www.linkedin.com/shareArticle?url=${this.link}&title=${title}`,
        );
        break;

      case `whatsapp`:
        window.location.href = `whatsapp://send?text=${encodeURIComponent(
          title,
        )} - ${encodeURIComponent(this.link)}`;
        break;

      default:
        window.open(
          `mailto:?subject=${escape(this.link)}&body=${title}:${this.link}`,
          ``,
        );
      }
    },
  },
};
